/**
 * This component tracks all the job cards across the website
 */
const onJobCardsClicked = () => {
    const jobCardsLinks = [...document.querySelectorAll('[data-js-amplitude-click]')];

    jobCardsLinks.forEach((item) => {
        const location = item?.getAttribute('data-js-location');
        const target   = item?.getAttribute('target');
        const isExternal = target === '_blank';

        item.addEventListener('click', function() {
            onSingleJobCardClicked(location, isExternal)
        })
    })
};

/**
 * Used on normal pages and also on job search sections
 */
const onSingleJobCardClicked = (location, isExternal) => {
    const eventName = 'wp_job_card_click';
    const type = isExternal ? 'external' : 'internal';

    if (!window.wp_amplitude) return;

    if (typeof window.wp_amplitude.event === 'undefined') return;

    window.wp_amplitude.event(eventName, {
        location: location,
        type: type
    });
}

export {onJobCardsClicked, onSingleJobCardClicked};
